import PropTypes from 'prop-types';
import { Component } from 'react';
import Flux from '../../flux/Flux';
import ActorStatus from '../SimpleElements/ActorStatus';
import Translations from '../../utils/Translations';

class NavbarMessagesDropdownItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isActorOnline: this.props.item.isActorOnline,
		};

		this.handleChannelSelect = this.handleChannelSelect.bind(this);
	}

	handleChannelSelect() {
		Flux.Messenger.selectChannelById(this.props.item.channelId, true);
	}

	render() {
		let liClassName = 'dropdown-menu__item h-cursor-pointer';
		if (this.props.item.unread) {
			liClassName += ' is-unread';
		}

		return (
			<li className="dropdown-menu__item__table">
				<a className={liClassName} onClick={this.handleChannelSelect}>
					<span className="dropdown-menu__item__cell">
						<ActorStatus isActorOnline={this.state.isActorOnline} previewPictureUrl={this.props.item.pictureUrl} size="md" />
					</span>
					<span className="dropdown-menu__item__cell -vertical-top">
						<span className="actor-name -navbar -extended">
							{this.props.item.actorName}{' '}
							<span className="message-period-text -font-small h-color-fg-hint">{this.props.item.sentDiffForHumans}</span>
						</span>
						<span className="message-subject -font-small -text-ellipsis">{Translations.get('NavbarMessageWroteMessageText')}</span>
						<span className="message-subject -font-small -line-height-xs h-text-underline h-disp-block">
							{Translations.get('NavbarMessageReadMessageText')}
						</span>
					</span>
				</a>
			</li>
		);
	}
}

NavbarMessagesDropdownItem.propTypes = {
	item: PropTypes.object.isRequired,
};

export default NavbarMessagesDropdownItem;
